<template>
  <page-header></page-header>

  <div class="innerBanner CouriersBanner position-relative">
    <div class="inBannerImg">
      <img src="../../assets/couriers_img.png" alt="Couriers" />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6">
        <div class="innerBannerText">
          <h1 class="text-uppercase">Agents de livraison</h1>
          <p class="fw-bold mb-1">
            En voiture avec ‘Postmedia Parcel Services’
          </p>
          <p>
            Notre entreprise est l'une des entreprises et des services qui
            connaissent la croissance la plus rapide sur le marché de la vente
            au détail d'aujourd'hui. Soyez votre propre patron, augmentez votre
            potentiel de gain et profitez d'un horaire qui correspond à votre
            style de vie.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="intersted-bg w-100 position-relative">
    <div class="container-sm position-relative">
      <div class="row">
        <div class="col-lg-6 mx-auto text-center">
          <h2 class="text-uppercase text-black sub_heading mb-0">
            Souhaitez-vous conduire pour nous ?
          </h2>
          <p class="mt-1 mb-4">En voiture avec ‘Postmedia Parcel Services’</p>
          <a
            href="#/fr/careers"
            class="bg-white d-inline-block click-here-btn position-relative"
          >
            <img src="../../assets/arrow.png" alt="arrow" class="img-fluid" />
            Cliquez ici</a
          >
        </div>
      </div>
    </div>
  </div>

  <div class="our-team position-relative">
    <div class="container-sm">
      <div class="row">
        <div class="col-lg-12 mx-auto our-team-content text-center">
          <p class="text-black">
            Notre entreprise est l'une des entreprises et des services qui
            connaissent la croissance la plus rapide sur le marché de la vente
            au détail d'aujourd'hui. Soyez votre propre patron, augmentez votre
            potentiel de gain et profitez d'un horaire qui correspond à votre
            style de vie.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="getInTouchSection">
    <div class="container-sm">
      <div class="getInTouch">
        <h5>
          <p>Vous avez besoin de plus d'informations ou de soutien ?</p>
          <a href="#/fr/support" title=""
            >Prenez contact avec nous dès aujourd'hui !</a
          >
        </h5>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>
<script>
import PageFooter from "../fr/PageFooter.vue";
import PageHeader from "../fr/PageHeader.vue";

export default {
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
  beforeMount() {
    scroll(0, 0);
  },
};
</script>